export default __webpack_public_path__ + "static/media/tamarindpowder.446c1bbf.jpeg";